import React from "react";
import { useTranslation } from "react-i18next";

/**
 * The pending-points chip: points this guest will earn WHEN THE CASHIER MARKS
 * THEIR ORDER PAID, and has not earned yet.
 *
 * This exists because the old wording was misread as an award that had already
 * happened. It said "+15 when you pay" — the number first, the condition
 * trailing — and it sat inside the jade "welcome back" card, borrowing the
 * treatment this app uses for things that are DONE, right next to the guest's
 * real balance. It scanned as "+15 has been added". It never had been: the
 * ledger is genuinely empty until Mark-paid (verified end to end on dev, and
 * the reason F-1 is not reopened).
 *
 * So the chip leads with the condition — "Pending: +15 on payment" — and is
 * deliberately styled AGAINST the earned treatment: dashed, unfilled, with an
 * hourglass. Nothing in this app that is dashed and unfilled has happened yet.
 *
 * `dark` renders it on the card's espresso band, where the cream chip would
 * disappear.
 */
export default function PendingPoints({ points, dark = false }) {
  const { t } = useTranslation();

  if (!(Number(points) > 0)) return null;

  return (
    <div className={`ss-pending${dark ? " dark" : ""}`}>
      <span className="ss-pending-ic" aria-hidden="true">⏳</span>
      <span className="ss-pending-lead">{t("scan_stay.order.points_pending_lead")}</span>
      <span className="ss-pending-val">
        {t("scan_stay.order.points_pending_rest", { pts: points })}
      </span>
    </div>
  );
}
